import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';

import { AppComponent } from './app.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {MatButtonModule, MatCheckboxModule} from '@angular/material';
import { MainMenuComponent } from './components/main-menu/main-menu.component';

import {MatMenuModule} from '@angular/material/menu';
import {MatIconModule} from '@angular/material/icon';
import {MatToolbarModule} from '@angular/material/toolbar';
import { AppRoutingModule } from './app-routing.module';

import { FlexLayoutModule } from '@angular/flex-layout';
import {MatInputModule} from '@angular/material/input';
import {MatFormFieldModule} from '@angular/material/form-field';
import { InitComponent } from './components/init/init.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import {MatCardModule} from '@angular/material/card';
import { CountCallBoxComponent } from './components/count-call-box/count-call-box.component';
import { DataIntegrationComponent } from './components/data-integration/data-integration.component';

import {MatTableModule} from '@angular/material/table';
import {ScrollDispatchModule} from '@angular/cdk/scrolling';

import {MatSelectModule} from '@angular/material/select';

import {MatSlideToggleModule} from '@angular/material/slide-toggle';

import { FormsModule } from '@angular/forms';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import { ToastComponent } from './components/toast/toast.component';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { LoadingComponent } from './components/loading/loading.component';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';

import { ReactiveFormsModule } from '@angular/forms';

import {MatAutocompleteModule} from '@angular/material/autocomplete';
import { BalanceBoxComponent } from './components/balance-box/balance-box.component';
import { RechargeHistoryComponent } from './components/recharge-history/recharge-history.component';

import { NgScrollbarModule } from 'ngx-scrollbar';

import {MatDatepickerModule} from '@angular/material/datepicker';
import { SumaryBoxesComponent } from './components/sumary-boxes/sumary-boxes.component';
import { SimpleTitleComponent } from './components/simple-title/simple-title.component';
import { PeersComponent } from './components/peers/peers.component';

import {MatDialogModule} from '@angular/material/dialog';
import { AddPeersComponent } from './components/popups/add-peers/add-peers.component';

import {MatRadioModule} from '@angular/material/radio';
import { DidsComponent } from './components/dids/dids.component';
import { AddDidsComponent } from './components/popups/add-dids/add-dids.component';
import { PaymentComponent } from './components/payment/payment.component';
import { BinasComponent } from './components/binas/binas.component';

import { LOCALE_ID } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import localePt from '@angular/common/locales/pt';
import { EditPeersComponent } from './components/popups/edit-peers/edit-peers.component';
import { ConfirmDialogComponent } from './components/popups/confirm-dialog/confirm-dialog.component';
import { AddBinasComponent } from './components/popups/add-binas/add-binas.component';
import { ConfirmBinasComponent } from './components/popups/confirm-binas/confirm-binas.component';
import { EditDidsComponent } from './components/popups/edit-dids/edit-dids.component';
import { PermissionsComponent } from './components/permissions/permissions.component';

import {MatProgressBarModule} from '@angular/material/progress-bar';

import { NgxPhoneMaskBrModule } from 'ngx-phone-mask-br';
import { CallsComponent } from './components/calls/calls.component';
import { TtsComponent } from './components/tts/tts.component';
import { ViewMessageTtsComponent } from './components/popups/view-message-tts/view-message-tts.component';
import {ScrollingModule} from '@angular/cdk/scrolling';



registerLocaleData(localePt, 'pt-BR');


@NgModule({
  declarations: [
    AppComponent,
    MainMenuComponent,
    InitComponent,
    DashboardComponent,
    CountCallBoxComponent,
    DataIntegrationComponent,
    ToastComponent,
    NotFoundComponent,
    LoadingComponent,
    BalanceBoxComponent,
    RechargeHistoryComponent,
    SumaryBoxesComponent,
    SimpleTitleComponent,
    PeersComponent,
    AddPeersComponent,
    DidsComponent,
    AddDidsComponent,
    PaymentComponent,
    BinasComponent,
    EditPeersComponent,
    ConfirmDialogComponent,
    AddBinasComponent,
    ConfirmBinasComponent,
    EditDidsComponent,
    PermissionsComponent,
    CallsComponent,
    TtsComponent,
    ViewMessageTtsComponent
  ],
  entryComponents: [
    ToastComponent,
    AddPeersComponent,
    AddDidsComponent,
    PaymentComponent,
    AddPeersComponent,
    EditPeersComponent,
    ConfirmDialogComponent,
    AddBinasComponent,
    ConfirmBinasComponent,
    EditDidsComponent,
    ViewMessageTtsComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    MatButtonModule,
    MatCheckboxModule,
    MatMenuModule,
    MatIconModule,
    MatToolbarModule,
    AppRoutingModule,
    FlexLayoutModule,
    MatInputModule,
    MatFormFieldModule,
    MatCardModule,
    MatTableModule,
    MatSelectModule,
    MatSlideToggleModule,
    FormsModule,
    HttpClientModule,
    MatSnackBarModule,
    MatProgressSpinnerModule,
    MatAutocompleteModule,
    ReactiveFormsModule,
    NgScrollbarModule,
    MatDatepickerModule,
    MatDialogModule,
    MatRadioModule,
    MatProgressBarModule,
    NgxPhoneMaskBrModule,
    ScrollingModule
  ],
  providers: [
      {provide: LOCALE_ID, useValue: 'pt-BR'}
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
